module.exports = __webpack_public_path__ + "img/NoInsuranceWhenCustomsValueDeclared.6a8dc42a.svg";